import { lowerCase, upperFirst } from 'lodash-es'
import { toast } from 'sonner'

export const GENERIC_ERROR = 'Something went wrong'
export const GENERIC_ERROR_CONTACT_US = 'Something went wrong. Please contact us.'

export function parseError(err: any) {
  if (err?.response?.status === 500) {
    return GENERIC_ERROR_CONTACT_US
  }

  const errorData = err?.response?.data || err
  // `error` is DRF's shape for our hand-rolled {"error": "..."} responses. Without it
  // the key branch below prefixes the message with its own key, giving "Error <msg>".
  const errors =
    errorData?.errors || errorData?.error || errorData?.data || errorData?.message || errorData || {}

  if (typeof errors === 'string') {
    if (errors.startsWith('<h1>Server Error')) return GENERIC_ERROR
    return errors
  }

  if (Array.isArray(errors)) {
    return errors.map(parseErrorMessage).join('\n')
  }

  const keys = Object.keys(errors)
  if (keys[0]) {
    return keys.map((key) => {
      const msg = `${upperFirst(lowerCase(key || ''))} ${parseErrorMessage(errors[key])}`
      return <div>{msg}</div>
    })
  }

  return GENERIC_ERROR
}

function parseErrorMessage(message: string | string[] | { code: string; detail: string }): any {
  if (Array.isArray(message)) return message.join(' ')

  if (typeof message === 'object') {
    if ('code' in message || 'detail' in message) {
      return `${upperFirst(lowerCase(message.code || ''))} ${message.detail || ''}`
    }

    // Text, not parseError's elements: this lands inside its caller's sentence.
    return Object.values(message as Record<string, string | string[]>)
      .map(parseErrorMessage)
      .join(' ')
  }

  return message
}

export async function handleError(cb: () => Promise<any>) {
  try {
    await cb()
  } catch (error) {
    toast.error(parseError(error))
  }
}
